import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import Videos from './components/Videos';
import Certificates from './components/Certificates';
import Programs from './components/Programs';
import Demos from './components/Demos';
import About from './components/About';
import AddUser from './components/AddUser';
import AddProgram from './components/AddProgram';
import AddVideo from './components/AddVideo';
import AddCertificate from './components/AddCertificate';
import DeleteUser from './components/DeleteUser';
import DeleteProgram from './components/DeleteProgram';
import DeleteVideo from './components/DeleteVideo';
import DeleteCertificate from './components/DeleteCertificate';
import View from './components/View';
import AddDemo from './components/AddDemo';
import DeleteDemo from './components/DeleteDemo';
import AddImage from './components/AddImage';
import DeleteImage from './components/DeleteImage';
import Images from './components/Images';

const App: React.FC = () => {
    const [loggedInUser, setLoggedInUser] = useState<string | null>(null);

    const handleLogout = (): void => {
        localStorage.removeItem('token');
        setLoggedInUser(null);
    };

    return (
        <div className="App">
            {(() => {
                if (loggedInUser && loggedInUser === "admin") {
                    return (
                        <Router>
                            <Routes>
                                <Route
                                    path="/"
                                    element={<Home username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/videos"
                                    element={<Videos username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/videos/:programName"
                                    element={<Videos username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/images"
                                    element={<Images username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/images/:programName"
                                    element={<Images username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/certificates"
                                    element={<Certificates username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/programs"
                                    element={<Programs username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/demos"
                                    element={<Demos username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/about"
                                    element={<About username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/adduser"
                                    element={<AddUser username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/addprogram"
                                    element={<AddProgram username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/addvideo"
                                    element={<AddVideo username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/addcertificate"
                                    element={<AddCertificate username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/adddemo"
                                    element={<AddDemo username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/addimage"
                                    element={<AddImage username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/deleteuser"
                                    element={<DeleteUser username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/deleteprogram"
                                    element={<DeleteProgram username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/deletevideo"
                                    element={<DeleteVideo username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/deletecertificate"
                                    element={<DeleteCertificate username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/deletedemo"
                                    element={<DeleteDemo username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/deleteimage"
                                    element={<DeleteImage username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/view"
                                    element={<View username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="*"
                                    element={<Navigate to="/" replace />}
                                />
                            </Routes>
                        </Router>
                    );
                } else if (loggedInUser && loggedInUser !== "admin") {
                    return (
                        <Router>
                            <Routes>
                                <Route
                                    path="/"
                                    element={<Home username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/videos"
                                    element={<Videos username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/videos/:programName"
                                    element={<Videos username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/images"
                                    element={<Images username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/images/:programName"
                                    element={<Images username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/certificates"
                                    element={<Certificates username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/programs"
                                    element={<Programs username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/demos"
                                    element={<Demos username={loggedInUser} onLogout={handleLogout} />}
                                />
                                <Route
                                    path="/about"
                                    element={<About username={loggedInUser} onLogout={handleLogout} />}
                                />
                                {/* Non-admins cannot access add/delete/view routes */}
                                <Route path="/adduser" element={<Navigate to="/" replace />} />
                                <Route path="/addprogram" element={<Navigate to="/" replace />} />
                                <Route path="/addvideo" element={<Navigate to="/" replace />} />
                                <Route path="/addcertificate" element={<Navigate to="/" replace />} />
                                <Route path="/adddemo" element={<Navigate to="/" replace />} />
                                <Route path="/addimage" element={<Navigate to="/" replace />} />
                                <Route path="/deleteuser" element={<Navigate to="/" replace />} />
                                <Route path="/deleteprogram" element={<Navigate to="/" replace />} />
                                <Route path="/deletevideo" element={<Navigate to="/" replace />} />
                                <Route path="/deletecertificate" element={<Navigate to="/" replace />} />
                                <Route path="/deletedemo" element={<Navigate to="/" replace />} />
                                <Route path="/deleteimage" element={<Navigate to="/" replace />} />
                                <Route path="/view" element={<Navigate to="/" replace />} />
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </Router>
                    );
                } else {
                    return (
                        <div>
                            <Login setLoggedInUser={setLoggedInUser} />
                        </div>
                    );
                }
            })()}
        </div>
    );
};

export default App;